import { makeStyles, createStyles } from '../../../styles';
export default makeStyles((theme) => createStyles({
    dropdown: {
        zIndex: theme.zIndex.menu,
    },
    paper: {
        backgroundColor: theme.palette.background.default,
    },
    menuList: {
        padding: 0,
    },
}));
//# sourceMappingURL=ActionBarSelect.styles.js.map